import { apiClient } from "@/services/HttpService";

export function loadProjectAuditorConfig(projectId, companyId) {
  return apiClient.get(`/auditor/${projectId}?companyId=${companyId}`);
}

export function loadProjectRiskReviewerConfig(projectId, companyId) {
  return apiClient.get(`/risk-reviewer/${projectId}?companyId=${companyId}`);
}